
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","fill":"none","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M50.523 24.72c-.43-5.54-5.73-9.28-11.24-8.54-2.34.32-4.37 1.21-5.7 2.39-1.57-1.35-3.7-2.23-6.21-2.46-5.18-.48-10.16 3.16-10.7 8.33a9.407 9.407 0 003.61 8.47v14.61c0 1.97 1.59 3.56 3.56 3.56h19.49c1.97 0 3.56-1.59 3.56-3.56V32.91a9.39 9.39 0 003.64-8.2l-.01.01z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M42.883 16.32c-.61-5.36-5.81-8.93-11.21-8.21-2.34.32-4.37 1.21-5.7 2.39-1.57-1.35-3.7-2.23-6.21-2.46-5.18-.46-10.16 3.17-10.71 8.35a9.407 9.407 0 003.61 8.47v14.61c0 1.97 1.59 3.56 3.56 3.56h4.05"}})])
          )
        }
      }
    